module.exports = __webpack_public_path__ + "img/2024-10-16e_1.08984501.jpg";